import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminQuoteRequests() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    apiClient.get("/admin/quote-requests").then((res) => setRequests(res.data));
  }, []);

  const setStatus = async (id, status) => {
    try {
      await apiClient.put(`/admin/quote-requests/${id}/status`, { status });
      setRequests((prev) => prev.map((r) => (r.id === id ? { ...r, status } : r)));
      toast.success(status === "handled" ? "Marked as handled" : "Reopened");
    } catch {
      toast.error("Could not update status");
    }
  };

  const newCount = requests.filter((r) => r.status === "new").length;

  return (
    <div data-testid="admin-quote-requests-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-semibold text-slate-900">Quote Requests</h1>
        <span className="text-sm text-slate-500" data-testid="admin-quote-requests-count">{newCount} new / {requests.length} total</span>
      </div>

      <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-slate-600">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Product</th>
              <th className="px-4 py-3">Qty</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Company / Institution</th>
              <th className="px-4 py-3">Message</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`admin-quote-request-row-${r.id}`}>
                <td className="px-4 py-3 whitespace-nowrap">{new Date(r.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3 font-medium text-slate-900">{r.product_name}</td>
                <td className="px-4 py-3 font-semibold">{r.quantity}</td>
                <td className="px-4 py-3">{r.name}</td>
                <td className="px-4 py-3"><a href={`mailto:${r.email}`} className="text-brandblue-600 hover:underline">{r.email}</a></td>
                <td className="px-4 py-3">{r.company || "—"}</td>
                <td className="px-4 py-3 max-w-[220px]"><span className="block truncate" title={r.message || ""}>{r.message || "—"}</span></td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${r.status === "handled" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                    {r.status === "handled" ? "Handled" : "New"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  {r.status === "handled" ? (
                    <Button size="sm" variant="ghost" onClick={() => setStatus(r.id, "new")} data-testid={`quote-reopen-btn-${r.id}`}>Reopen</Button>
                  ) : (
                    <Button size="sm" variant="outline" className="rounded-full" onClick={() => setStatus(r.id, "handled")} data-testid={`quote-handle-btn-${r.id}`}>Mark Handled</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {requests.length === 0 && <p className="p-6 text-center text-slate-400 text-sm" data-testid="admin-no-quote-requests">No quote requests yet.</p>}
      </div>
    </div>
  );
}
